import { omit } from "lodash";
import type { Section } from "../../types/Event";

/**
 * Turns the output of `getFormFormattedValues` into the payload the `/unassigned-shifts` endpoints expect
 */
export const getUnassignedShiftFormattedValues = (data: any, slots: any) => ({
    ...omit(data, ["user"]),
    slots: Number(slots) || 1,
    sections: data?.sections?.map((section: Section) => ({
        ...section,
        location: {
            code: section?.location?.code,
            description: section?.location?.description,
            displayName: section?.location?.displayName,
            id: section?.location?.id,
            locationId: section?.location?.id,
            status: section?.location?.status,
            timezoneId: section?.location?.timezoneId,
            timezoneValue: section?.location?.timezoneValue
        },
        job: {
            code: section?.job?.code,
            description: section?.job?.description,
            id: section?.job?.id,
            status: section?.job?.status
        }
    }))
});
